import { useState, useEffect } from 'react';
import type Announcement from '../models/announcement';
import getAllAnnouncementsByOfficeId from '../services/announcements.services';
import { useKeycloak } from '../../authentication/keycloak/KeycloakProvider';

interface InitialAnnouncementState {
  readonly initialized: boolean;
  readonly error?: boolean;
  readonly errorNumber?: number;
}

interface AnnouncementsState extends InitialAnnouncementState {
  readonly announcements?: Announcement[];
}

interface Props {
  readonly id: string | undefined;
}

const useAnnouncements = ({ id }: Props): AnnouncementsState => {
  const [state, setState] = useState<AnnouncementsState>({
    initialized: false,
  });
  const keycloak = useKeycloak();

  useEffect(() => {
    const getAnnouncements = async (): Promise<void> => {
      try {
        if (!id || id === '') {
          return;
        }

        const announcements = await getAllAnnouncementsByOfficeId(id, new Date(), keycloak);

        if (typeof announcements === 'number') {
          setState({
            initialized: true,
            error: true,
            errorNumber: announcements,
            announcements: [],
          });
        } else {
          setState({ initialized: true, announcements });
        }
      } catch (error) {
        setState({ initialized: false, error: true });
      }
    };

    if (!state.initialized) {
      getAnnouncements();
    }
  }, [setState, state.initialized, keycloak, id]);

  return state;
};

export default useAnnouncements;
